export const GET_ZONES = 'GET_ZONES'
export const GET_ZONES_EXITO = 'GET_ZONES_EXITO'
export const GET_ZONES_ERRROR = 'GET_ZONES_ERROR'
